import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../store/hooks';

/** Days before expiry when the learner is warned to renew. */
export const SUBSCRIPTION_WARNING_DAYS = 3;

/** The signed-in learner's active plan (from the current-user API) with expiry helpers. */
export const useSubscription = () => {
    const subscription = useAppSelector((state) => state.auth.user?.subscription ?? null);

    return useMemo(() => {
        if (!subscription) {
            return { subscription: null, daysLeft: null, isExpiringSoon: false, expiresAtText: '' };
        }
        const expiresAt = dayjs(subscription.expires_at);
        // Whole calendar days between today and the expiry date; 0 means it expires today.
        const daysLeft = Math.max(expiresAt.startOf('day').diff(dayjs().startOf('day'), 'day'), 0);
        return {
            subscription,
            daysLeft,
            isExpiringSoon: daysLeft <= SUBSCRIPTION_WARNING_DAYS,
            expiresAtText: expiresAt.format('HH:mm DD/MM/YYYY'),
        };
    }, [subscription]);
};
